import exists from './exists';

export const GRAPHQL_VALIDATION_ERROR_CODE = 'BAD_USER_INPUT';

export const GENERIC_ERROR = 'genericError';

export const throwExceptions = (err) => {
  if (!err) return;

  const { graphQLErrors, fetchError, httpError } = err;

  const nonUserErrorFound = graphQLErrors && graphQLErrors.find(
    (error) => (error.extensions.code !== GRAPHQL_VALIDATION_ERROR_CODE)
  );

  if (nonUserErrorFound || fetchError || httpError) {
    throw err;
  }
};

export const getErrorsByField = (mutationError = {}) => {
  const { graphQLErrors } = mutationError;
  if (!graphQLErrors) {
    return {};
  }

  // Format validation errors to align with their fields
  return graphQLErrors
    .filter((error) => (
      error.extensions.code === GRAPHQL_VALIDATION_ERROR_CODE
        && error.extensions.validationErrors
        && Array.isArray(error.extensions.validationErrors)
    ))
    .reduce((arr, err) => (arr.concat(err.extensions.validationErrors)), [])
    .reduce((obj, err) => {
      const {
        dataPath,
        instancePath,
        keyword,
        message,
        params
      } = err;
      if (keyword === 'if') {
        return obj;
      }
      // If unformatted validation error, treat like any other exception
      if (!instancePath && !dataPath) {
        throw mutationError;
      }
      const path = instancePath?.split('.').reverse()[0] || dataPath;
      const target = exists(params.missingProperty) ? params.missingProperty : path;

      return {
        ...obj,
        [target]: (obj[target] || []).concat([keyword]).concat([message])
      };
    }, {});
};
